import { render, staticRenderFns } from "./changeAppend.vue?vue&type=template&id=5398d32c&scoped=true&"
import script from "./changeAppend.vue?vue&type=script&lang=js&"
export * from "./changeAppend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5398d32c",
  null
  
)

export default component.exports